/**
 * Professional data-source badge for chart headers / toolbars.
 * Shows Live · NSE Realtime · Delayed · Historical — never reconnecting/polling chrome.
 */
import { resolveDataSource } from '../utils/dataSource';

/**
 * @param {object} props
 * @param {string} [props.source]
 * @param {string} [props.via]
 * @param {string} [props.mode]
 * @param {boolean} [props.socketLive]
 * @param {boolean} [props.intraday]
 * @param {number|null} [props.lastSuccess]
 * @param {string} [props.className]
 * @param {boolean} [props.showDot]
 * @param {object} [props.resolved]  precomputed resolveDataSource() result
 */
export default function DataSourceBadge({
  source = '',
  via = '',
  mode = '',
  socketLive = false,
  intraday = true,
  lastSuccess = null,
  className = '',
  showDot = true,
  resolved = null,
}) {
  const ds = resolved || resolveDataSource({
    source,
    via,
    mode,
    socketLive,
    intraday,
    lastSuccess,
  });

  if (!ds.label || ds.kind === 'idle') return null;

  return (
    <span
      className={`ic-ds-badge ic-ds-${ds.tone}${className ? ` ${className}` : ''}`}
      title={ds.title}
      data-source={ds.kind}
    >
      {showDot && <span className="ic-ds-dot" aria-hidden="true" />}
      <span className="ic-ds-label">{ds.label}</span>
    </span>
  );
}
